const geojsonData = {
  type: "FeatureCollection",

  features: [
   
    {
      "type": "Feature",
      "id": "smb59d5d44",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.104613736, 40.705203644],
            [-74.102274849, 40.693433774],
            [-74.102274849, 40.693433774],
            [-74.099828675, 40.684883654],
            [-74.099013284, 40.68446873],
            [-74.088477566, 40.685322983],
            [-74.087919666, 40.685859936],
            [-74.090880825, 40.706212161],
            [-74.104613736, 40.705203644]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB01"
      }
    },
    {
      "type": "Feature",
      "id": "sm7ac8eff8",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.080609552, 40.688695795],
            [-74.086382635, 40.688210765],
            [-74.086085036, 40.686047054],
            [-74.085291102, 40.685591458],
            [-74.080806449, 40.686006376],
            [-74.080291465, 40.686518917],
            [-74.080609552, 40.688695795]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB09",
      }
    },
    {
      "type": "Feature",
      "id": "sm84ef9590",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.086382635, 40.688210765],
            [-74.080609552, 40.688695795],
            [-74.080987539, 40.691282509],
            [-74.086738682, 40.690799341],
            [-74.086382635, 40.688210765]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB08",
      }
    },
    {
      "type": "Feature",
      "id": "sm6ded68bc",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.086738682, 40.690799341],
            [-74.080987539, 40.691282509],
            [-74.081369059, 40.693893299],
            [-74.087098057, 40.693412011],
            [-74.086738682, 40.690799341]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB07",
      }
    },
    {
      "type": "Feature",
      "id": "sm6eb5bf7d",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.087098057, 40.693412011],
            [-74.081369059, 40.693893299],
            [-74.081746675, 40.696477276],
            [-74.087453755, 40.695997848],
            [-74.087098057, 40.693412011]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB06",
      }
    },
    {
      "type": "Feature",
      "id": "sm000cc1cb",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.087453755, 40.695997848],
            [-74.081746675, 40.696477276],
            [-74.082123915, 40.699058577],
            [-74.087826534, 40.698576989],
            [-74.087544158, 40.696655035],
            [-74.087453755, 40.695997848]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB05",
      }
    },
    {
      "type": "Feature",
      "id": "smdc4c2667",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.087826534, 40.698576989],
            [-74.082123915, 40.699058577],
            [-74.082503882, 40.701658438],
            [-74.088208501, 40.701176701],
            [-74.087826534, 40.698576989]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB04",
      }
    },
    {
      "type": "Feature",
      "id": "sm24e74a91",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.088208501, 40.701176701],
            [-74.082503882, 40.701658438],
            [-74.082883837, 40.704258118],
            [-74.088590455, 40.70377623],
            [-74.088208501, 40.701176701]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB03",
      }
    },
    {
      "type": "Feature",
      "id": "sm4f54cd13",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.088590455, 40.70377623],
            [-74.082883837, 40.704258118],
            [-74.083263351, 40.706854677],
            [-74.088971092, 40.706366691],
            [-74.088590455, 40.70377623]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB02",
      }
    },
    {
      "type": "Feature",
      "id": "smd35970b4",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.044885304, 40.692407616],
            [-74.044216334, 40.68759297],
            [-74.041163399, 40.687836862],
            [-74.041163399, 40.687836862],
            [-74.041871502, 40.692652835],
            [-74.044885304, 40.692407616]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB21",
      }
    },
    {
      "type": "Feature",
      "id": "sm749e1f96",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.044216334, 40.68759297],
            [-74.044885304, 40.692407616],
            [-74.047977532, 40.692156014],
            [-74.047309192, 40.687345888],
            [-74.044216334, 40.68759297]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB20",
      }
    },
    {
      "type": "Feature",
      "id": "sm20f47342",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.047309192, 40.687345888],
            [-74.047977532, 40.692156014],
            [-74.05104407, 40.691906501],
            [-74.050376356, 40.687100857],
            [-74.047309192, 40.687345888]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB19",
      }
    },
    {
      "type": "Feature",
      "id": "sm875ad9f8",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.050376356, 40.687100857],
            [-74.05104407, 40.691906501],
            [-74.054128529, 40.69165553],
            [-74.053461444, 40.686854394],
            [-74.050376356, 40.687100857]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB18",
      }
    },
    {
      "type": "Feature",
      "id": "sm230e02d8",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.053461444, 40.686854394],
            [-74.054128529, 40.69165553],
            [-74.05720848, 40.691404925],
            [-74.056542023, 40.68660829],
            [-74.053461444, 40.686854394]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB17",
      }
    },
    {
      "type": "Feature",
      "id": "sme64bbec1",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.056542023, 40.68660829],
            [-74.05720848, 40.691404925],
            [-74.060345378, 40.691149685],
            [-74.05967956, 40.686357635],
            [-74.056542023, 40.68660829]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB16",
      }
    },
    {
      "type": "Feature",
      "id": "sm6e3ecc23",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.05967956, 40.686357635],
            [-74.060345378, 40.691149685],
            [-74.063397442, 40.690901347],
            [-74.062732247, 40.686113758],
            [-74.05967956, 40.686357635]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB15",
      }
    },
    {
      "type": "Feature",
      "id": "sm959596dd",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.062732247, 40.686113758],
            [-74.063397442, 40.690901347],
            [-74.066526534, 40.69064674],
            [-74.065861977, 40.685863725],
            [-74.062732247, 40.686113758]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB14",
      }
    },
    {
      "type": "Feature",
      "id": "sm3a3c9a38",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.065861977, 40.685863725],
            [-74.066526534, 40.69064674],
            [-74.069552873, 40.690400493],
            [-74.068888933, 40.685621902],
            [-74.065861977, 40.685863725]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB13",
      }
    },
    {
      "type": "Feature",
      "id": "sm4f53e36c",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.068888933, 40.685621902],
            [-74.069552873, 40.690400493],
            [-74.07267636, 40.69014634],
            [-74.072013057, 40.685372315],
            [-74.068888933, 40.685621902]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB12",
      }
    },
    {
      "type": "Feature",
      "id": "sm586d0350",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.072013057, 40.685372315],
            [-74.07267636, 40.69014634],
            [-74.075726188, 40.68989818],
            [-74.075063507, 40.685128613],
            [-74.072013057, 40.685372315]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB11",
      }
    },
    {
      "type": "Feature",
      "id": "smcd8244b1",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.075063507, 40.685128613],
            [-74.075726188, 40.68989818],
            [-74.078263714, 40.689691704],
            [-74.078810884, 40.689171053],
            [-74.078231528, 40.684875517],
            [-74.075063507, 40.685128613]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB10",
      }
    },
    {
      "type": "Feature",
      "id": "sm89c18bbc",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.046415528, 40.70355661],
            [-74.045742136, 40.698747764],
            [-74.042642215, 40.698997264],
            [-74.043244796, 40.703300428],
            [-74.043244796, 40.703300428],
            [-74.043995814, 40.703755902],
            [-74.046415528, 40.70355661]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB45",
      }
    },
    {
      "type": "Feature",
      "id": "sm1fc3905b",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.045742136, 40.698747764],
            [-74.046415528, 40.70355661],
            [-74.049476012, 40.703304542],
            [-74.048803418, 40.698501374],
            [-74.045742136, 40.698747764]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB44",
      }
    },
    {
      "type": "Feature",
      "id": "sm8644e7cd",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.048803418, 40.698501374],
            [-74.049476012, 40.703304542],
            [-74.052591128, 40.703047974],
            [-74.051919344, 40.698250584],
            [-74.048803418, 40.698501374]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB43",
      }
    },
    {
      "type": "Feature",
      "id": "smbd9de06a",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.051919344, 40.698250584],
            [-74.052591128, 40.703047974],
            [-74.05570399, 40.70279159],
            [-74.055033019, 40.697999974],
            [-74.051919344, 40.698250584]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB42",
      }
    },
    {
      "type": "Feature",
      "id": "sma180065f",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.055033019, 40.697999974],
            [-74.05570399, 40.70279159],
            [-74.058741371, 40.702541422],
            [-74.05807119, 40.697755441],
            [-74.055033019, 40.697999974]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB41",
      }
    },
    {
      "type": "Feature",
      "id": "smd7e84db7",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.05807119, 40.697755441],
            [-74.058741371, 40.702541422],
            [-74.061885762, 40.70228244],
            [-74.0612164, 40.697502291],
            [-74.05807119, 40.697755441]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB40",
      }
    },
    {
      "type": "Feature",
      "id": "sm3e04c5d8",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.0612164, 40.697502291],
            [-74.061885762, 40.70228244],
            [-74.064920529, 40.702032486],
            [-74.064251958, 40.697257966],
            [-74.0612164, 40.697502291]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB39",
      }
    },
    {
      "type": "Feature",
      "id": "sm58459338",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.064251958, 40.697257966],
            [-74.064920529, 40.702032486],
            [-74.067996777, 40.701779114],
            [-74.067329008, 40.6970103],
            [-74.064251958, 40.697257966]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB38",
      }
    },
    {
      "type": "Feature",
      "id": "sm8b6465a2",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.067329008, 40.6970103],
            [-74.067996777, 40.701779114],
            [-74.071127656, 40.701521241],
            [-74.070460703, 40.696758235],
            [-74.067329008, 40.6970103]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB37",
      }
    },
    {
      "type": "Feature",
      "id": "sm0903bd0d",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.070460703, 40.696758235],
            [-74.071127656, 40.701521241],
            [-74.07422381, 40.701266228],
            [-74.073557663, 40.696508965],
            [-74.070460703, 40.696758235]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB36",
      }
    },
    {
      "type": "Feature",
      "id": "smcdde6af6",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.073557663, 40.696508965],
            [-74.07422381, 40.701266228],
            [-74.077323523, 40.701010921],
            [-74.076658184, 40.696259407],
            [-74.073557663, 40.696508965]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB35",
      }
    },
    {
      "type": "Feature",
      "id": "sm572247c5",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.076658184, 40.696259407],
            [-74.077323523, 40.701010921],
            [-74.079744295, 40.700811534],
            [-74.08034511, 40.700242165],
            [-74.079713876, 40.696013457],
            [-74.076658184, 40.696259407]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB34",
      }
    },
    {
      "type": "Feature",
      "id": "sm15cd8ac7",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.07594328, 40.691287996],
            [-74.076639269, 40.69626093],
            [-74.079713876, 40.696013457],
            [-74.079036192, 40.691473278],
            [-74.078392462, 40.691090935],
            [-74.07594328, 40.691287996]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB33",
      }
    },
    {
      "type": "Feature",
      "id": "smd9ef0cb7",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.076639269, 40.69626093],
            [-74.07594328, 40.691287996],
            [-74.072836948, 40.691537931],
            [-74.073532953, 40.696510954],
            [-74.076639269, 40.69626093]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB32",
      }
    },
    {
      "type": "Feature",
      "id": "sme0879da9",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.073532953, 40.696510954],
            [-74.072836948, 40.691537931],
            [-74.069726457, 40.6917882],
            [-74.070422477, 40.696761312],
            [-74.073532953, 40.696510954]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB31",
      }
    },
    {
      "type": "Feature",
      "id": "smdf79ab4b",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.070422477, 40.696761312],
            [-74.069726457, 40.6917882],
            [-74.066602455, 40.692039555],
            [-74.06729849, 40.697012756],
            [-74.070422477, 40.696761312]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB30",
      }
    },
    {
      "type": "Feature",
      "id": "sm99ef704f",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.06729849, 40.697012756],
            [-74.066602455, 40.692039555],
            [-74.063522103, 40.692287397],
            [-74.064218452, 40.697260662],
            [-74.06729849, 40.697012756]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB29",
      }
    },
    {
      "type": "Feature",
      "id": "sm094fa48b",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.064218452, 40.697260662],
            [-74.063522103, 40.692287397],
            [-74.060454048, 40.692534249],
            [-74.061150413, 40.697507601],
            [-74.064218452, 40.697260662]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB28",
      }
    },
    {
      "type": "Feature",
      "id": "sm23056f84",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.061150413, 40.697507601],
            [-74.060454048, 40.692534249],
            [-74.057389916, 40.692780784],
            [-74.058086296, 40.697754224],
            [-74.061150413, 40.697507601]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB27",
      }
    },
    {
      "type": "Feature",
      "id": "sm24c5a2b8",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.058086296, 40.697754224],
            [-74.057389916, 40.692780784],
            [-74.054307401, 40.693028797],
            [-74.055003796, 40.698002326],
            [-74.058086296, 40.697754224]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB26",
      }
    },
    {
      "type": "Feature",
      "id": "sm65f73982",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.055003796, 40.698002326],
            [-74.054307401, 40.693028797],
            [-74.051187899, 40.693279785],
            [-74.05188431, 40.698253404],
            [-74.055003796, 40.698002326]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB25",
      }
    },
    {
      "type": "Feature",
      "id": "smd5cdf5e9",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.05188431, 40.698253404],
            [-74.051187899, 40.693279785],
            [-74.048092814, 40.693528808],
            [-74.048789239, 40.698502515],
            [-74.05188431, 40.698253404]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB24",
      }
    },
    {
      "type": "Feature",
      "id": "smaa1763f8",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.048789239, 40.698502515],
            [-74.048092814, 40.693528808],
            [-74.045005432, 40.69377721],
            [-74.045701872, 40.698751005],
            [-74.048789239, 40.698502515]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB23",
      }
    },
    {
      "type": "Feature",
      "id": "sm498ef815",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.045701872, 40.698751005],
            [-74.045005432, 40.69377721],
            [-74.042601064, 40.693970658],
            [-74.042043165, 40.69471904],
            [-74.042642215, 40.698997264],
            [-74.045701872, 40.698751005]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB22",
      }
    },
    {
      "type": "Feature",
      "id": "sm6aea261b",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.013547929, 40.706238343],
            [-74.012873872, 40.701402127],
            [-74.009767657, 40.701650944],
            [-74.010371645, 40.705984429],
            [-74.011165578, 40.706439884],
            [-74.013547929, 40.706238343]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB55",
      }
    },
    {
      "type": "Feature",
      "id": "sm6028fa48",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.012873872, 40.701402127],
            [-74.013547929, 40.706238343],
            [-74.016620951, 40.705978371],
            [-74.0159488, 40.701155815],
            [-74.012873872, 40.701402127]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB54",
      }
    },
    {
      "type": "Feature",
      "id": "sme34814b0",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.0159488, 40.701155815],
            [-74.016620951, 40.705978371],
            [-74.019703976, 40.705717552],
            [-74.019033738, 40.700908701],
            [-74.0159488, 40.701155815]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB53",
      }
    },
    {
      "type": "Feature",
      "id": "sm69777c6f",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.019033738, 40.700908701],
            [-74.019703976, 40.705717552],
            [-74.022815972, 40.705454281],
            [-74.022147665, 40.700659263],
            [-74.019033738, 40.700908701]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB52",
      }
    },
    {
      "type": "Feature",
      "id": "sm9f947a94",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.022147665, 40.700659263],
            [-74.022815972, 40.705454281],
            [-74.025963981, 40.705187962],
            [-74.025297627, 40.700406938],
            [-74.022147665, 40.700659263]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB51",
      }
    },
    {
      "type": "Feature",
      "id": "sm3ab67eea",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.025297627, 40.700406938],
            [-74.025963981, 40.705187962],
            [-74.029000109, 40.704931107],
            [-74.028335639, 40.70016358],
            [-74.025297627, 40.700406938]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB50",
      }
    },
    {
      "type": "Feature",
      "id": "sm4eccccfa",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.028335639, 40.70016358],
            [-74.029000109, 40.704931107],
            [-74.032113306, 40.704667731],
            [-74.031450766, 40.699914044],
            [-74.028335639, 40.70016358]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB49",
      }
    },
    {
      "type": "Feature",
      "id": "sm4e8d2cfb",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.031450766, 40.699914044],
            [-74.032113306, 40.704667731],
            [-74.035172883, 40.704408891],
            [-74.034512242, 40.699668804],
            [-74.031450766, 40.699914044]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB48",
      }
    },
    {
      "type": "Feature",
      "id": "smd8bbf3cf",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.034512242, 40.699668804],
            [-74.035172883, 40.704408891],
            [-74.038292802, 40.704144945],
            [-74.037634096, 40.699418727],
            [-74.034512242, 40.699668804]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB47",
      }
    },
    {
      "type": "Feature",
      "id": "smd71bb94d",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.037634096, 40.699418727],
            [-74.038292802, 40.704144945],
            [-74.040584044, 40.703951104],
            [-74.041313605, 40.703430564],
            [-74.040699059, 40.699173206],
            [-74.037634096, 40.699418727]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB46",
      }
    },
    {
      "type": "Feature",
      "id": "sm09ea1ce9",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.036891269, 40.694558598],
            [-74.037569312, 40.699423916],
            [-74.040699059, 40.699173206],
            [-74.04006906, 40.694808517],
            [-74.039307317, 40.694361118],
            [-74.039307317, 40.694361118],
            [-74.036891269, 40.694558598]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB65",
      }
    },
    {
      "type": "Feature",
      "id": "smcc0a77db",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.037569312, 40.699423916],
            [-74.036891269, 40.694558598],
            [-74.033814307, 40.694810098],
            [-74.034491661, 40.699670452],
            [-74.037569312, 40.699423916]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB64",
      }
    },
    {
      "type": "Feature",
      "id": "sm4d070d77",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.034491661, 40.699670452],
            [-74.033814307, 40.694810098],
            [-74.030702118, 40.695064476],
            [-74.031378776, 40.69991981],
            [-74.034491661, 40.699670452]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB63",
      }
    },
    {
      "type": "Feature",
      "id": "sme22c3e9e",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.031378776, 40.69991981],
            [-74.030702118, 40.695064476],
            [-74.027605622, 40.69531757],
            [-74.028281586, 40.70016791],
            [-74.031378776, 40.69991981]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB62",
      }
    },
    {
      "type": "Feature",
      "id": "sm6ada76ce",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.028281586, 40.70016791],
            [-74.027605622, 40.69531757],
            [-74.024551557, 40.695567196],
            [-74.025226837, 40.700412609],
            [-74.028281586, 40.70016791]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB61",
      }
    },
    {
      "type": "Feature",
      "id": "sm7a6b0094",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.025226837, 40.700412609],
            [-74.024551557, 40.695567196],
            [-74.021460585, 40.695819837],
            [-74.022135173, 40.700660264],
            [-74.025226837, 40.700412609]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB60",
      }
    },
    {
      "type": "Feature",
      "id": "smf64c8700",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.022135173, 40.700660264],
            [-74.021460585, 40.695819837],
            [-74.01836633, 40.696072746],
            [-74.019040225, 40.700908181],
            [-74.022135173, 40.700660264]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB59",
      }
    },
    {
      "type": "Feature",
      "id": "sm6ce088f1",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.019040225, 40.700908181],
            [-74.01836633, 40.696072746],
            [-74.015259186, 40.696326707],
            [-74.015932384, 40.70115713],
            [-74.019040225, 40.700908181]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB58",
      }
    },
    {
      "type": "Feature",
      "id": "sm99c416d6",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.015932384, 40.70115713],
            [-74.015259186, 40.696326707],
            [-74.012167173, 40.69657943],
            [-74.012839678, 40.701404866],
            [-74.015932384, 40.70115713]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB57",
      }
    },
    {
      "type": "Feature",
      "id": "sm3f60509f",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.012839678, 40.701404866],
            [-74.012167173, 40.69657943],
            [-74.009749372, 40.696777046],
            [-74.009170015, 40.697362713],
            [-74.009767657, 40.701650944],
            [-74.012839678, 40.701404866]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB56",
      }
    },
    {
      "type": "Feature",
      "id": "smf0b6c91e",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.00767595, 40.700465406],
            [-74.00421883, 40.70072923],
            [-74.00434204, 40.706228426],
            [-74.007775268, 40.705935632],
            [-74.008333167, 40.705415107],
            [-74.00767595, 40.700465406]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB78",
      }
    },
    {
      "type": "Feature",
      "id": "sme13881c4",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.00421883, 40.70072923],
            [-74.00767595, 40.700465406],
            [-74.007064565, 40.695860554],
            [-74.004114799, 40.696085676],
            [-74.00421883, 40.70072923]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB77",
      }
    },
    {
      "type": "Feature",
      "id": "sm05eed7cf",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.004114799, 40.696085676],
            [-74.007064565, 40.695860554],
            [-74.007024249, 40.695556893],
            [-74.010407066, 40.695278004],
            [-74.009713195, 40.690439677],
            [-74.003998717, 40.69090383],
            [-74.003998717, 40.69090383],
            [-74.004114799, 40.696085676]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB76",
      }
    },
    {
      "type": "Feature",
      "id": "smc4c58367",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.009713195, 40.690439677],
            [-74.010407066, 40.695278004],
            [-74.013426314, 40.695029088],
            [-74.012732967, 40.690194397],
            [-74.009713195, 40.690439677]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB75",
      }
    },
    {
      "type": "Feature",
      "id": "sm0a62fda5",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.012732967, 40.690194397],
            [-74.013426314, 40.695029088],
            [-74.016542374, 40.694772189],
            [-74.015849567, 40.689941251],
            [-74.012732967, 40.690194397]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB74",
      }
    },
    {
      "type": "Feature",
      "id": "smc8121067",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.015849567, 40.689941251],
            [-74.016542374, 40.694772189],
            [-74.019584188, 40.694521411],
            [-74.01889191, 40.689694136],
            [-74.015849567, 40.689941251]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB73",
      }
    },
    {
      "type": "Feature",
      "id": "sm95516c28",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.01889191, 40.689694136],
            [-74.019584188, 40.694521411],
            [-74.022721001, 40.6942628],
            [-74.022029267, 40.689439303],
            [-74.01889191, 40.689694136]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB72",
      }
    },
    {
      "type": "Feature",
      "id": "sm7adca1fb",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.022029267, 40.689439303],
            [-74.022721001, 40.6942628],
            [-74.025753828, 40.694012761],
            [-74.025072769, 40.689192092],
            [-74.022029267, 40.689439303]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB71",
      }
    },
    {
      "type": "Feature",
      "id": "smcbd84daf",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.025072769, 40.689192092],
            [-74.025753828, 40.694012761],
            [-74.028886918, 40.693754455],
            [-74.028206395, 40.68893756],
            [-74.025072769, 40.689192092]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB70",
      }
    },
    {
      "type": "Feature",
      "id": "sm2be27e18",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.028206395, 40.68893756],
            [-74.028886918, 40.693754455],
            [-74.031954879, 40.693501517],
            [-74.031274881, 40.688688318],
            [-74.028206395, 40.68893756]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB69",
      }
    },
    {
      "type": "Feature",
      "id": "sm80651cf3",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.031274881, 40.688688318],
            [-74.031954879, 40.693501517],
            [-74.035091764, 40.693242896],
            [-74.034412303, 40.688433476],
            [-74.031274881, 40.688688318]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB68",
      }
    },
    {
      "type": "Feature",
      "id": "smbdad6c88",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.034412303, 40.688433476],
            [-74.035091764, 40.693242896],
            [-74.038144569, 40.692991206],
            [-74.037465629, 40.688185463],
            [-74.034412303, 40.688433476]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB67",
      }
    },
    {
      "type": "Feature",
      "id": "smeb2b6f53",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.037465629, 40.688185463],
            [-74.038144569, 40.692991206],
            [-74.041163405, 40.692742316],
            [-74.040455302, 40.68794262],
            [-74.037465629, 40.688185463]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB66",
      }
    },
    {
      "type": "Feature",
      "id": "sm0fac1735",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.009123106, 40.715789726],
            [-74.004620707, 40.716136319],
            [-74.004663901, 40.718268447],
            [-74.004728274, 40.72028507],
            [-74.009674268, 40.719902892],
            [-74.009123106, 40.715789726]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB82",
      }
    },
    {
      "type": "Feature",
      "id": "sm3ffce3bc",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.004620707, 40.716136319],
            [-74.009123106, 40.715789726],
            [-74.009116369, 40.71573945],
            [-74.009867387, 40.715682526],
            [-74.009582628, 40.713679339],
            [-74.004579211, 40.714087968],
            [-74.004620707, 40.716136319]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB81",
      }
    },
    {
      "type": "Feature",
      "id": "sm31d6449a",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.004579211, 40.714087968],
            [-74.009582628, 40.713679339],
            [-74.009153659, 40.710661569],
            [-74.004517472, 40.711040224],
            [-74.004579211, 40.714087968]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB80",
      }
    },
    {
      "type": "Feature",
      "id": "smaa80bb82",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.004517472, 40.711040224],
            [-74.009153659, 40.710661569],
            [-74.008740862, 40.707757438],
            [-74.008011301, 40.707350789],
            [-74.004449327, 40.707676108],
            [-74.004517472, 40.711040224]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB79",
      }
    },
    {
      "type": "Feature",
      "id": "sm633a1546",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.024991277, 40.710921561],
            [-74.025543755, 40.714855022],
            [-74.029268919, 40.714554416],
            [-74.028708054, 40.710617339],
            [-74.024991277, 40.710921561]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB93",
      }
    },
    {
      "type": "Feature",
      "id": "sm1b7a14b1",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.028708054, 40.710617339],
            [-74.028116522, 40.706464733],
            [-74.025091603, 40.706712341],
            [-74.02448006, 40.707281654],
            [-74.024991277, 40.710921561],
            [-74.028708054, 40.710617339]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB94",
      }
    },
    {
      "type": "Feature",
      "id": "sm877e1571",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.078208073, 40.707281418],
            [-74.081278517, 40.707029532],
            [-74.080720618, 40.702645678],
            [-74.079937413, 40.702222731],
            [-74.077515749, 40.702420972],
            [-74.078208073, 40.707281418]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB111",
      }
    },
    {
      "type": "Feature",
      "id": "sm2b345342",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.077515749, 40.702420972],
            [-74.074414455, 40.702674847],
            [-74.075106859, 40.707535827],
            [-74.078208073, 40.707281418],
            [-74.077515749, 40.702420972]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB110",
      }
    },
    {
      "type": "Feature",
      "id": "sma8a35b90",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.074414455, 40.702674847],
            [-74.071326904, 40.702927597],
            [-74.072019385, 40.707789108],
            [-74.075106859, 40.707535827],
            [-74.074414455, 40.702674847]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB109",
      }
    },
    {
      "type": "Feature",
      "id": "sm66b2c4f5",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.071326904, 40.702927597],
            [-74.068200018, 40.703183565],
            [-74.068892579, 40.708045615],
            [-74.072019385, 40.707789108],
            [-74.071326904, 40.702927597]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB108",
      }
    },
    {
      "type": "Feature",
      "id": "sm49327944",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.068200018, 40.703183565],
            [-74.065160564, 40.703432375],
            [-74.065853201, 40.708294949],
            [-74.068892579, 40.708045615],
            [-74.068200018, 40.703183565]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB107",
      }
    },
    {
      "type": "Feature",
      "id": "sm5a671711",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.065160564, 40.703432375],
            [-74.062068432, 40.703685496],
            [-74.062761148, 40.708548603],
            [-74.065853201, 40.708294949],
            [-74.065160564, 40.703432375]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB106",
      }
    },
    {
      "type": "Feature",
      "id": "sm9557691b",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.062068432, 40.703685496],
            [-74.059005576, 40.70393622],
            [-74.05969837, 40.708799854],
            [-74.062761148, 40.708548603],
            [-74.062068432, 40.703685496]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB105",
      }
    },
    {
      "type": "Feature",
      "id": "smc7f3ff47",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.059005576, 40.70393622],
            [-74.055849416, 40.704194581],
            [-74.05654229, 40.709058758],
            [-74.05969837, 40.708799854],
            [-74.059005576, 40.70393622]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB104",
      }
    },
    {
      "type": "Feature",
      "id": "sm2d0bba45",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.055849416, 40.704194581],
            [-74.052796319, 40.704444504],
            [-74.05348927, 40.709309207],
            [-74.05654229, 40.709058758],
            [-74.055849416, 40.704194581]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB103",
      }
    },
    {
      "type": "Feature",
      "id": "sm7ff25f37",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.052796319, 40.704444504],
            [-74.049744317, 40.704694337],
            [-74.050437346, 40.709559565],
            [-74.05348927, 40.709309207],
            [-74.052796319, 40.704444504]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB102",
      }
    },
    {
      "type": "Feature",
      "id": "smc3af572d",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.049744317, 40.704694337],
            [-74.046609466, 40.704950951],
            [-74.047302574, 40.709816718],
            [-74.050437346, 40.709559565],
            [-74.049744317, 40.704694337]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB101",
      }
    },
    {
      "type": "Feature",
      "id": "smb393fe72",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.046609466, 40.704950951],
            [-74.043495526, 40.705205852],
            [-74.044188714, 40.710072155],
            [-74.047302574, 40.709816718],
            [-74.046609466, 40.704950951]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB100",
      }
    },
    {
      "type": "Feature",
      "id": "smb1021ca5",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.043495526, 40.705205852],
            [-74.040430878, 40.705456717],
            [-74.041124143, 40.710323548],
            [-74.044188714, 40.710072155],
            [-74.043495526, 40.705205852]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB99",
      }
    },
    {
      "type": "Feature",
      "id": "sme391dc2a",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.040430878, 40.705456717],
            [-74.03735862, 40.705708204],
            [-74.038053472, 40.71057544],
            [-74.041124143, 40.710323548],
            [-74.040430878, 40.705456717]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB98",
      }
    },
    {
      "type": "Feature",
      "id": "sm86e85bf8",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.03735862, 40.705708204],
            [-74.034254282, 40.705962316],
            [-74.034947705, 40.71083021],
            [-74.038053472, 40.71057544],
            [-74.03735862, 40.705708204]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB97",
      }
    },
    {
      "type": "Feature",
      "id": "sm82108dfa",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.034254282, 40.705962316],
            [-74.031158466, 40.70621573],
            [-74.031851967, 40.711084156],
            [-74.034947705, 40.71083021],
            [-74.034254282, 40.705962316]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB96",
      }
    },
    {
      "type": "Feature",
      "id": "smbae150ac",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.031158466, 40.70621573],
            [-74.028116522, 40.706464733],
            [-74.029268919, 40.714554416],
            [-74.029449621, 40.714539834],
            [-74.028932527, 40.71132364],
            [-74.031851967, 40.711084156],
            [-74.031158466, 40.70621573]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB95",
      }
    },
    {
      "type": "Feature",
      "id": "smf5195465",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.025543755, 40.714855022],
            [-74.025681689, 40.71583703],
            [-74.025681689, 40.71583703],
            [-74.025662798, 40.715838622],
            [-74.026089358, 40.718746377],
            [-74.030080513, 40.718463606],
            [-74.029449621, 40.714539834],
            [-74.025543755, 40.714855022]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB92",
      }
    },
    {
      "type": "Feature",
      "id": "smf29e5059",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.025662798, 40.715838622],
            [-74.020564062, 40.716268316],
            [-74.020980685, 40.719108321],
            [-74.026089358, 40.718746377],
            [-74.025662798, 40.715838622]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB91",
      }
    },
    {
      "type": "Feature",
      "id": "sm32e865fc",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.020564062, 40.716268316],
            [-74.015305116, 40.716711508],
            [-74.01571149, 40.719481636],
            [-74.020980685, 40.719108321],
            [-74.020564062, 40.716268316]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB84",
      }
    },
    {
      "type": "Feature",
      "id": "smd363189c",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.015305116, 40.716711508],
            [-74.009953217, 40.717162531],
            [-74.010339455, 40.719862235],
            [-74.01571149, 40.719481636],
            [-74.015305116, 40.716711508]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB83",
      }
    },
    {
      "type": "Feature",
      "id": "sm94bd6efd",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.01106203, 40.710454178],
            [-74.016963772, 40.709990448],
            [-74.01661624, 40.70744901],
            [-74.011347965, 40.707883494],
            [-74.010779337, 40.708428399],
            [-74.01106203, 40.710454178]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB87",
      }
    },
    {
      "type": "Feature",
      "id": "smf1e80604",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.016963772, 40.709990448],
            [-74.01106203, 40.710454178],
            [-74.011414376, 40.712978997],
            [-74.017309123, 40.712515835],
            [-74.016963772, 40.709990448]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB86",
      }
    },
    {
      "type": "Feature",
      "id": "sm5cda7038",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.017309123, 40.712515835],
            [-74.011414376, 40.712978997],
            [-74.011702017, 40.715040093],
            [-74.012399391, 40.715446695],
            [-74.017653483, 40.715033886],
            [-74.017309123, 40.712515835]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB85",
      }
    },
    {
      "type": "Feature",
      "id": "smcdee62d6",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.023263249, 40.711992167],
            [-74.017301568, 40.712460592],
            [-74.017653483, 40.715033886],
            [-74.022956565, 40.714617225],
            [-74.023600295, 40.714113032],
            [-74.023263249, 40.711992167]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB90",
      }
    },
    {
      "type": "Feature",
      "id": "sm7f3980a1",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.017301568, 40.712460592],
            [-74.023263249, 40.711992167],
            [-74.023262338, 40.711986434],
            [-74.022921854, 40.709494518],
            [-74.016960015, 40.709962973],
            [-74.017301568, 40.712460592]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB89",
      }
    },
    {
      "type": "Feature",
      "id": "sm66ca0fba",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-74.016960015, 40.709962973],
            [-74.022921854, 40.709494518],
            [-74.022640066, 40.707432115],
            [-74.021899776, 40.707013264],
            [-74.01661624, 40.70744901],
            [-74.016960015, 40.709962973]
          ]
        ]
      },
      "properties": {
         Unit_Number: "KB88",
      }
    }
  ],
};

export default geojsonData;
